import { FormControl, Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import { OPRadioButton } from '../../../OPcomponents/OPRadioButton'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const EducationCard = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange, handleChange } = useCVSettings()
  const { inc_education, inc_eduschool, inc_edufinish, inc_eduinfo, educationOption } = state

  const educationOptions = [
    {
      value: 'all',
      label: t('CVTemplates.AllEducations'),
    },
    {
      value: 'highest',
      label: t('CVTemplates.HighestDegreeOnly'),
    },
    {
      value: 'key',
      label: t('CVTemplates.OnlyKeyEducations'),
    },
  ]

  return (
    <CVCard
      title={t('CVTemplates.Education')}
      description={t('CVTemplates.EducationHistoryAndDegrees')}
      isEnabled={inc_education}
      toggleName='inc_education'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <FormControl component='fieldset'>
          <OPRadioButton
            direction='column'
            name='educationOption'
            radioOptions={educationOptions}
            label=''
            onChange={handleChange}
            defaultVal={educationOption}
          />
        </FormControl>
      </Grid>
      <Grid item>
        <OPCheckBox name='inc_eduschool' label={t('CVTemplates.ShowSchool')} value={inc_eduschool} onChangeState={handleSwitchChange} />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_edufinish'
          label={t('CVTemplates.ShowCompletionDate')}
          value={inc_edufinish}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='inc_eduinfo'
          label={t('CVTemplates.ShowEducationDetails')}
          value={inc_eduinfo}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
